/**
 * AUTO-GENERATED — DO NOT EDIT BY HAND.
 *
 * Generated by `scripts/generate-operation-capability.ts` (TV1-1867).
 * Run `yarn generate-all` to regenerate after changing the capability
 * registry or route-config.json. A drift check fails CI if this file is
 * stale.
 *
 * The registry inverse: every `private` operation in route-config.json
 * mapped to the single Capability that owns it. Used by the FE authorization
 * gate to derive a capability from an operation id without hand-typing a
 * capability string.
 */
import type { CapabilityKey } from './registry';

export type OperationId =
  | 'accounting:accounts'
  | 'accounting:add-account'
  | 'accounting:close-fiscal-period'
  | 'accounting:create-chart-of-accounts'
  | 'accounting:fiscal-period-readmodel'
  | 'accounting:journal-entry-list-readmodel'
  | 'accounting:ledger-by-account-readmodel'
  | 'accounting:lock-account'
  | 'accounting:open-fiscal-period'
  | 'accounting:reclassify-account'
  | 'accounting:record-journal-entry'
  | 'accounting:rename-account'
  | 'accounting:reverse-journal-entry'
  | 'accounting:trial-balance-readmodel'
  | 'analytics:activate-ui-widget-layout'
  | 'analytics:add-ui-widget-layout'
  | 'analytics:change-ui-widget-layout'
  | 'analytics:deactivate-ui-widget-layout'
  | 'analytics:generate-report'
  | 'analytics:observed-operations-readmodel'
  | 'analytics:remove-ui-widget-layout'
  | 'analytics:ui-widget-layouts-readmodel'
  | 'automation:approve-sub-goal'
  | 'automation:automation-requests'
  | 'automation:automation-requests-summary'
  | 'automation:define-rule-definition'
  | 'automation:delete-rule-definition'
  | 'automation:re-evaluate-publication-rules'
  | 'automation:record-sub-goal-composed'
  | 'automation:record-sub-goal-composition-attempt-failed'
  | 'automation:record-sub-goal-input-values'
  | 'automation:record-sub-goal-promoted'
  | 'automation:record-sub-goal-unsatisfiable'
  | 'automation:reject-sub-goal'
  | 'automation:remove-rule'
  | 'automation:retry-rule-execution'
  | 'automation:rule-definitions'
  | 'automation:rule-execution-batches'
  | 'automation:rule-execution-batches-search'
  | 'automation:rule-executions'
  | 'automation:rule-executions-search'
  | 'automation:rule-executions-status-counts'
  | 'automation:rules'
  | 'automation:rules-draft'
  | 'automation:rules-dry-run'
  | 'automation:set-rule'
  | 'automation:set-rules'
  | 'automation:stock-thresholds-readmodel'
  | 'automation:submit-automation-request'
  | 'automation:unshadow-rule'
  | 'automation:withdraw-automation-request'
  | 'batch-processes:archive-batch-process'
  | 'batch-processes:batch-processes'
  | 'batch-processes:cancel-batch-process'
  | 'batch-processes:progress'
  | 'batch-processes:progress-count'
  | 'batch-processes:retry-batch-process'
  | 'batch-processes:start-channel-order-import-batch-process'
  | 'batch-processes:start-channel-publication-import-batch-process'
  | 'batch-processes:start-publication-bulk-edit-batch-process'
  | 'batch-processes:start-publication-creation-batch-process'
  | 'batch-processes:start-publication-item-extraction'
  | 'batch-processes:start-publication-status-changed-batch-process'
  | 'batch-processes:start-publication-sync-from-channel-batch-process'
  | 'batch-processes:start-publications-duplication-batch-process'
  | 'batch-processes:unarchive-batch-process'
  | 'billing:account-termination-preview'
  | 'billing:add-my-subscription-card'
  | 'billing:aggregate'
  | 'billing:amount-due'
  | 'billing:archive-product'
  | 'billing:card-on-file'
  | 'billing:create-product'
  | 'billing:create-product-bundle'
  | 'billing:delete-product'
  | 'billing:pay-attempt'
  | 'billing:pay-my-subscription'
  | 'billing:products'
  | 'billing:publications'
  | 'billing:publish-product'
  | 'billing:publish-rate-plan-version'
  | 'billing:sales'
  | 'billing:subscription-invoices'
  | 'billing:unarchive-product'
  | 'billing:update-product-charge-templates'
  | 'billing:update-product-name'
  | 'clients-management:accounts-readmodel'
  | 'clients-management:add-account-user'
  | 'clients-management:add-group-member'
  | 'clients-management:assignment-groups-readmodel'
  | 'clients-management:change-dashboard-report'
  | 'clients-management:change-user-language'
  | 'clients-management:clients-management-configuration-readmodel'
  | 'clients-management:complete-billing-entity-wizard'
  | 'clients-management:create-assignment-group'
  | 'clients-management:create-subscription-plan'
  | 'clients-management:create-user-preferences'
  | 'clients-management:delete-assignment-group'
  | 'clients-management:delete-subscription-plan'
  | 'clients-management:dismiss-billing-entity-wizard'
  | 'clients-management:erase-account-data'
  | 'clients-management:erase-user-data'
  | 'clients-management:generate-app-login-url'
  | 'clients-management:get-login-user'
  | 'clients-management:me'
  | 'clients-management:observation-state'
  | 'clients-management:register-user-for-business-account'
  | 'clients-management:register-user-profile'
  | 'clients-management:remove-account-user'
  | 'clients-management:remove-group-member'
  | 'clients-management:remove-user-profile'
  | 'clients-management:rename-assignment-group'
  | 'clients-management:reopen-billing-entity-wizard'
  | 'clients-management:set-new-accounts-subscription-plan'
  | 'clients-management:set-trial-plan-duration'
  | 'clients-management:subscription-plans-readmodel'
  | 'clients-management:suspension-status'
  | 'clients-management:update-account-info'
  | 'clients-management:update-subscription-plan'
  | 'clients-management:update-user-profile'
  | 'clients-management:user-preferences'
  | 'clients-management:users-profiles'
  | 'feature-flags:archive-feature-flag'
  | 'feature-flags:create-feature-flag'
  | 'feature-flags:disable-feature-flag'
  | 'feature-flags:enable-feature-flag'
  | 'feature-flags:feature-flags'
  | 'feature-flags:import-feature-flags'
  | 'feature-flags:org-resolved-flags'
  | 'feature-flags:schedule-feature-flag'
  | 'feature-flags:update-feature-flag'
  | 'generic:realtime-session'
  | 'generic:upload-file'
  | 'generic:upload-image'
  | 'identity:add-auth-user-password'
  | 'identity:admin-ban-user'
  | 'identity:admin-create-admin-user'
  | 'identity:admin-impersonate'
  | 'identity:admin-list-sessions'
  | 'identity:admin-revoke-all-sessions'
  | 'identity:admin-revoke-session'
  | 'identity:admin-set-password'
  | 'identity:admin-stop-impersonating'
  | 'identity:admin-unban-user'
  | 'identity:assign-account-membership'
  | 'identity:auth-user-security'
  | 'identity:auth-user-security-search'
  | 'identity:ban-auth-user'
  | 'identity:capability-registry'
  | 'identity:change-auth-user-password'
  | 'identity:custom-roles'
  | 'identity:define-custom-role'
  | 'identity:delete-auth-account'
  | 'identity:delete-auth-user'
  | 'identity:edit-custom-role'
  | 'identity:flags'
  | 'identity:forgot-password'
  | 'identity:impersonate-auth-user'
  | 'identity:logout-authentication-user'
  | 'identity:me'
  | 'identity:my-capabilities'
  | 'identity:passkey-delete'
  | 'identity:passkey-register-start'
  | 'identity:register-auth-account'
  | 'identity:register-auth-user'
  | 'identity:register-passkey'
  | 'identity:remove-account-membership'
  | 'identity:remove-custom-role'
  | 'identity:reset-password'
  | 'identity:revoke-all-auth-user-sessions'
  | 'identity:revoke-auth-user-session'
  | 'identity:revoke-passkey'
  | 'identity:role-create'
  | 'identity:role-delete'
  | 'identity:role-update'
  | 'identity:set-active-account'
  | 'identity:set-auth-user-password'
  | 'identity:stop-impersonating-auth-user'
  | 'identity:system-roles'
  | 'identity:unban-auth-user'
  | 'identity:update-auth-account'
  | 'identity:update-auth-user'
  | 'identity:update-membership-roles'
  | 'invoicing:add-billing-entity'
  | 'invoicing:billing-entities'
  | 'invoicing:billing-entity-points-of-sale'
  | 'invoicing:buyer-invoice-preferences'
  | 'invoicing:confirm-credit-note'
  | 'invoicing:confirm-debit-note'
  | 'invoicing:disable-billing-entity'
  | 'invoicing:edit-billing-entity'
  | 'invoicing:fiscal-documents'
  | 'invoicing:generate-invoice'
  | 'invoicing:generate-invoice-from-order'
  | 'invoicing:issue-credit-note'
  | 'invoicing:issue-credit-note-from-reversal'
  | 'invoicing:issue-debit-note'
  | 'invoicing:issue-fiscal-note'
  | 'invoicing:taxpayer-registry'
  | 'invoicing:void-invoice'
  | 'items-publishing:account-configuration-readmodel'
  | 'items-publishing:add-publication'
  | 'items-publishing:apply-bulk-items-change'
  | 'items-publishing:apply-bulk-price-change'
  | 'items-publishing:change-conflicted-sku'
  | 'items-publishing:change-inventory-list-preferences'
  | 'items-publishing:channels-commisions'
  | 'items-publishing:channels-publication-default-values-type'
  | 'items-publishing:channels-publication-form-type'
  | 'items-publishing:create-item-with-stock'
  | 'items-publishing:create-items-publishing-account-configuration'
  | 'items-publishing:create-items-publishing-user-preferences'
  | 'items-publishing:delete-item'
  | 'items-publishing:delete-price-list'
  | 'items-publishing:delete-publication'
  | 'items-publishing:delete-size-guide'
  | 'items-publishing:destroy-items-publishing-user-preferences'
  | 'items-publishing:duplicate-diff'
  | 'items-publishing:duplicate-publication'
  | 'items-publishing:edit-item'
  | 'items-publishing:edit-publication'
  | 'items-publishing:fenicio-publications-readmodel'
  | 'items-publishing:generate-sku'
  | 'items-publishing:get-sku-template'
  | 'items-publishing:import-publication'
  | 'items-publishing:import-publications'
  | 'items-publishing:inventory'
  | 'items-publishing:inventory-distinct-categories'
  | 'items-publishing:inventory-search'
  | 'items-publishing:inventory-spreadsheet'
  | 'items-publishing:inventory-stock-break'
  | 'items-publishing:item-delete-preflight'
  | 'items-publishing:mercadolibre-categories'
  | 'items-publishing:mercadolibre-discover-category-by-title'
  | 'items-publishing:mercadolibre-search-products-catalog'
  | 'items-publishing:merge-items'
  | 'items-publishing:order-items-search'
  | 'items-publishing:price-lists'
  | 'items-publishing:productos'
  | 'items-publishing:productos-parcial'
  | 'items-publishing:publication-drift-episodes'
  | 'items-publishing:publication-drift-episodes-search'
  | 'items-publishing:publications'
  | 'items-publishing:publications-bulk-edit-results'
  | 'items-publishing:publications-count'
  | 'items-publishing:publications-distinct-categories'
  | 'items-publishing:publications-retail-codes'
  | 'items-publishing:publications-search'
  | 'items-publishing:publicationsIds'
  | 'items-publishing:record-external-publication-error'
  | 'items-publishing:register-item'
  | 'items-publishing:release-composite-components'
  | 'items-publishing:relist-publication'
  | 'items-publishing:remove-category-sku-formula-override'
  | 'items-publishing:search'
  | 'items-publishing:set-category-sku-formula-override'
  | 'items-publishing:set-item-composition'
  | 'items-publishing:set-publication-channel-values'
  | 'items-publishing:size-guides'
  | 'items-publishing:size-guides-active-domains'
  | 'items-publishing:size-guides-channel-charts'
  | 'items-publishing:size-guides-publish-to-channel'
  | 'items-publishing:size-guides-search'
  | 'items-publishing:substitute-bom-components'
  | 'items-publishing:upsert-inventory-bulk-edit-views'
  | 'items-publishing:upsert-inventory-price-lists-views'
  | 'items-publishing:upsert-inventory-stock-lists-views'
  | 'items-publishing:upsert-price-list'
  | 'items-publishing:upsert-publications-bulk-edit-views'
  | 'items-publishing:upsert-size-guide'
  | 'items-publishing:user-preferences-readmodel'
  | 'items-publishing:validate-publication'
  | 'marketplace-health:listing-visits-readmodel'
  | 'marketplace-health:marketplace-health-force-sync'
  | 'marketplace-health:seller-reputation-readmodel'
  | 'ml-and-ai:add-assistant-message'
  | 'ml-and-ai:add-user-message'
  | 'ml-and-ai:ai-assistant-feedback'
  | 'ml-and-ai:ai-assistant-send-message'
  | 'ml-and-ai:ai-assistant-submit-automation-request'
  | 'ml-and-ai:conversation-messages'
  | 'ml-and-ai:conversations'
  | 'ml-and-ai:fail-agent-run'
  | 'ml-and-ai:finish-agent-run'
  | 'ml-and-ai:interrupt-agent-run'
  | 'ml-and-ai:resume-agent-run'
  | 'ml-and-ai:start-agent-run'
  | 'notifications:mark-notification-as-read'
  | 'notifications:mark-notification-as-unread'
  | 'notifications:notifications'
  | 'notifications:notifications-count'
  | 'notifications:send-user-notification'
  | 'operations:amend-change-item'
  | 'operations:approve-operation'
  | 'operations:change-sets'
  | 'operations:fail-operation-compute'
  | 'operations:propose-operation'
  | 'operations:reject-operation'
  | 'operations:runs'
  | 'operations:runs-search'
  | 'procurement:cancel-purchase-order'
  | 'procurement:clear-preferred-supplier'
  | 'procurement:deactivate-supplier'
  | 'procurement:edit-supplier'
  | 'procurement:item-sourcing'
  | 'procurement:map-supplier-sku'
  | 'procurement:place-purchase-order'
  | 'procurement:purchase-orders'
  | 'procurement:reactivate-supplier'
  | 'procurement:register-supplier'
  | 'procurement:set-preferred-supplier'
  | 'procurement:suppliers'
  | 'procurement:unmap-supplier-sku'
  | 'sales:account-configuration'
  | 'sales:answer-channel-question'
  | 'sales:assign-billing-entity'
  | 'sales:cancel-order'
  | 'sales:change-order-status'
  | 'sales:create-sales-account-configuration'
  | 'sales:crm-force-sync-questions'
  | 'sales:customers'
  | 'sales:customers-search'
  | 'sales:messages'
  | 'sales:order-statuses'
  | 'sales:orders'
  | 'sales:orders-count'
  | 'sales:orders-search'
  | 'sales:ordersIds'
  | 'sales:outbound-messages'
  | 'sales:place-order'
  | 'sales:questions'
  | 'sales:record-shipment-status'
  | 'sales:register-customer'
  | 'sales:register-shipment'
  | 'sales:return-order'
  | 'sales:reversal-fact-readmodel'
  | 'sales:sales-analytics-readmodel'
  | 'sales:send-channel-message'
  | 'sales:send-free-text-channel-message'
  | 'sales:set-order-statuses'
  | 'stock-management:apply-bulk-stock-change'
  | 'stock-management:delete-warehouse-item'
  | 'stock-management:edit-warehouse'
  | 'stock-management:increase-warehouse-item-stock-available'
  | 'stock-management:initialize-multiple-warehouse-items-stock'
  | 'stock-management:initialize-warehouse-item-stock'
  | 'stock-management:modify-warehouse-assignment'
  | 'stock-management:movements-by-order'
  | 'stock-management:register-warehouse'
  | 'stock-management:remove-warehouse'
  | 'stock-management:set-default-warehouse'
  | 'stock-management:set-warehouse-item-stock-available'
  | 'stock-management:shortfalls'
  | 'stock-management:stock-analytics-readmodel'
  | 'stock-management:update-multiple-warehouse-items-stock'
  | 'stock-management:warehouse-config'
  | 'stock-management:warehouses'
  | 'systems-integrations:account-emails'
  | 'systems-integrations:assign-integration-assignee'
  | 'systems-integrations:by-sku'
  | 'systems-integrations:change-system-integration-connector-state'
  | 'systems-integrations:change-system-integration-state'
  | 'systems-integrations:channel-categories'
  | 'systems-integrations:channel-categories-search'
  | 'systems-integrations:channel-import-preview'
  | 'systems-integrations:channel-import-preview-discard'
  | 'systems-integrations:channel-import-preview-fetch-by-i-ds'
  | 'systems-integrations:channel-import-preview-prepare'
  | 'systems-integrations:channel-import-preview-resolve-selection'
  | 'systems-integrations:channel-import-preview-stop'
  | 'systems-integrations:confirm-systems-integrations-element-operation'
  | 'systems-integrations:confirm-systems-integrations-operation'
  | 'systems-integrations:erp-container-import-price-list-import'
  | 'systems-integrations:erp-container-import-warehouse-import'
  | 'systems-integrations:erp-drift-episodes'
  | 'systems-integrations:erp-drift-episodes-search'
  | 'systems-integrations:erp-drift-recheck'
  | 'systems-integrations:erp-price-import-price-import'
  | 'systems-integrations:erp-stock-import-stock-import'
  | 'systems-integrations:erp-sync-mirror'
  | 'systems-integrations:erp-sync-mirror-search'
  | 'systems-integrations:external-logistics-integrations'
  | 'systems-integrations:external-systems-integrations'
  | 'systems-integrations:link-mercadolibre-from-login'
  | 'systems-integrations:map-channel-category'
  | 'systems-integrations:mark-channel-category-unmappable'
  | 'systems-integrations:mark-integration-credential-restored'
  | 'systems-integrations:mark-integration-credential-revoked'
  | 'systems-integrations:order-shipments-readmodel'
  | 'systems-integrations:price-import-projection'
  | 'systems-integrations:price-list-discovery'
  | 'systems-integrations:provision-system-integration'
  | 'systems-integrations:provision-system-integration-connector'
  | 'systems-integrations:read-external-systems'
  | 'systems-integrations:record-account-email-outcome'
  | 'systems-integrations:remove-integration-assignee'
  | 'systems-integrations:request-categories-resync'
  | 'systems-integrations:request-erp-bulk-import'
  | 'systems-integrations:request-systems-integrations-element-operation'
  | 'systems-integrations:request-systems-integrations-operation'
  | 'systems-integrations:send-account-email'
  | 'systems-integrations:stock-import-projection'
  | 'systems-integrations:storefront-link'
  | 'systems-integrations:sync-channel-categories'
  | 'systems-integrations:systems-integrations-connectors'
  | 'systems-integrations:systems-integrations-poll-publications'
  | 'systems-integrations:systems-integrations-poll-shipments'
  | 'systems-integrations:test-channel-create-publication'
  | 'systems-integrations:test-channel-edit-publication'
  | 'systems-integrations:test-channel-logistics-shipment-update'
  | 'systems-integrations:test-channel-poll-shipment-statuses'
  | 'systems-integrations:test-channel-record-invoice'
  | 'systems-integrations:test-channel-remove-publication'
  | 'systems-integrations:test-channel-set-invoicing-behavior'
  | 'systems-integrations:test-channel-sync-publication'
  | 'systems-integrations:test-channel-update-order-status'
  | 'systems-integrations:test-channel-update-publication-stock'
  | 'systems-integrations:unmap-channel-category'
  | 'systems-integrations:update-system-integration-configuration'
  | 'systems-integrations:update-system-integration-connector-configuration'
  | 'systems-integrations:warehouse-discovery';

export const operationCapability: Record<OperationId, CapabilityKey> = {
  'accounting:accounts': 'accounting:read',
  'accounting:add-account': 'accounting:accounts:create',
  'accounting:close-fiscal-period': 'accounting:fiscal-period:close',
  'accounting:create-chart-of-accounts': 'accounting:accounts:create',
  'accounting:fiscal-period-readmodel': 'accounting:read',
  'accounting:journal-entry-list-readmodel': 'accounting:read',
  'accounting:ledger-by-account-readmodel': 'accounting:read',
  'accounting:lock-account': 'accounting:accounts:update',
  'accounting:open-fiscal-period': 'accounting:fiscal-period:open',
  'accounting:reclassify-account': 'accounting:accounts:update',
  'accounting:record-journal-entry': 'accounting:journal-entries:record',
  'accounting:rename-account': 'accounting:accounts:update',
  'accounting:reverse-journal-entry': 'accounting:journal-entries:reverse',
  'accounting:trial-balance-readmodel': 'accounting:read',
  'analytics:activate-ui-widget-layout': 'analytics:layouts:update',
  'analytics:add-ui-widget-layout': 'analytics:layouts:create',
  'analytics:change-ui-widget-layout': 'analytics:layouts:update',
  'analytics:deactivate-ui-widget-layout': 'analytics:layouts:update',
  'analytics:generate-report': 'analytics:reports:generate',
  'analytics:observed-operations-readmodel': 'analytics:observed-operations:read',
  'analytics:remove-ui-widget-layout': 'analytics:layouts:delete',
  'analytics:ui-widget-layouts-readmodel': 'analytics:layouts:read',
  'automation:approve-sub-goal': 'automation:automation-requests:review',
  'automation:automation-requests': 'automation:automation-requests:read',
  'automation:automation-requests-summary': 'automation:automation-requests:read',
  'automation:define-rule-definition': 'automation:rule-definitions:create',
  'automation:delete-rule-definition': 'automation:rule-definitions:delete',
  'automation:re-evaluate-publication-rules': 'automation:executions:re-evaluate',
  'automation:record-sub-goal-composed': 'automation:automation-requests:record-outcomes',
  'automation:record-sub-goal-composition-attempt-failed': 'automation:automation-requests:record-outcomes',
  'automation:record-sub-goal-input-values': 'automation:automation-requests:promote',
  'automation:record-sub-goal-promoted': 'automation:automation-requests:promote',
  'automation:record-sub-goal-unsatisfiable': 'automation:automation-requests:record-outcomes',
  'automation:reject-sub-goal': 'automation:automation-requests:review',
  'automation:remove-rule': 'automation:rules:delete',
  'automation:retry-rule-execution': 'automation:executions:retry',
  'automation:rule-definitions': 'automation:rule-definitions:read',
  'automation:rule-execution-batches': 'automation:executions:read',
  'automation:rule-execution-batches-search': 'automation:executions:read',
  'automation:rule-executions': 'automation:executions:read',
  'automation:rule-executions-search': 'automation:executions:read',
  'automation:rule-executions-status-counts': 'automation:executions:read',
  'automation:rules': 'automation:rules:read',
  'automation:rules-draft': 'automation:rules:update',
  'automation:rules-dry-run': 'automation:rules:update',
  'automation:set-rule': 'automation:rules:update',
  'automation:set-rules': 'automation:rules:update',
  'automation:stock-thresholds-readmodel': 'automation:rules:read',
  'automation:submit-automation-request': 'automation:automation-requests:submit',
  'automation:unshadow-rule': 'automation:rules:update',
  'automation:withdraw-automation-request': 'automation:automation-requests:withdraw',
  'batch-processes:archive-batch-process': 'batch-processes:processes:update',
  'batch-processes:batch-processes': 'batch-processes:processes:read',
  'batch-processes:cancel-batch-process': 'batch-processes:processes:update',
  'batch-processes:progress': 'batch-processes:processes:read',
  'batch-processes:progress-count': 'batch-processes:processes:read',
  'batch-processes:retry-batch-process': 'batch-processes:processes:update',
  'batch-processes:start-channel-order-import-batch-process': 'batch-processes:processes:start',
  'batch-processes:start-channel-publication-import-batch-process': 'batch-processes:processes:start',
  'batch-processes:start-publication-bulk-edit-batch-process': 'batch-processes:processes:start',
  'batch-processes:start-publication-creation-batch-process': 'batch-processes:processes:start',
  'batch-processes:start-publication-item-extraction': 'batch-processes:internal',
  'batch-processes:start-publication-status-changed-batch-process': 'batch-processes:processes:start',
  'batch-processes:start-publication-sync-from-channel-batch-process': 'batch-processes:processes:start',
  'batch-processes:start-publications-duplication-batch-process': 'batch-processes:processes:start',
  'batch-processes:unarchive-batch-process': 'batch-processes:processes:update',
  'billing:account-termination-preview': 'billing:internal',
  'billing:add-my-subscription-card': 'billing:my-subscription:manage-card',
  'billing:aggregate': 'billing:usage:read',
  'billing:amount-due': 'billing:my-subscription:read',
  'billing:archive-product': 'billing:products:update',
  'billing:card-on-file': 'billing:my-subscription:read',
  'billing:create-product': 'billing:products:create',
  'billing:create-product-bundle': 'billing:products:create',
  'billing:delete-product': 'billing:products:delete',
  'billing:pay-attempt': 'billing:my-subscription:read',
  'billing:pay-my-subscription': 'billing:my-subscription:pay',
  'billing:products': 'billing:products:read',
  'billing:publications': 'billing:usage:read',
  'billing:publish-product': 'billing:products:publish',
  'billing:publish-rate-plan-version': 'billing:products:publish',
  'billing:sales': 'billing:usage:read',
  'billing:subscription-invoices': 'billing:my-subscription:read',
  'billing:unarchive-product': 'billing:products:update',
  'billing:update-product-charge-templates': 'billing:products:update',
  'billing:update-product-name': 'billing:products:update',
  'clients-management:accounts-readmodel': 'clients-management:account:read',
  'clients-management:add-account-user': 'clients-management:account:members:create',
  'clients-management:add-group-member': 'clients-management:assignment-groups:update',
  'clients-management:assignment-groups-readmodel': 'clients-management:assignment-groups:read',
  'clients-management:change-dashboard-report': 'clients-management:user-profiles:update',
  'clients-management:change-user-language': 'clients-management:user-profiles:update',
  'clients-management:clients-management-configuration-readmodel': 'clients-management:account:read',
  'clients-management:complete-billing-entity-wizard': 'clients-management:account:update',
  'clients-management:create-assignment-group': 'clients-management:assignment-groups:create',
  'clients-management:create-subscription-plan': 'clients-management:subscription:create',
  'clients-management:create-user-preferences': 'clients-management:user-profiles:create',
  'clients-management:delete-assignment-group': 'clients-management:assignment-groups:delete',
  'clients-management:delete-subscription-plan': 'clients-management:subscription:delete',
  'clients-management:dismiss-billing-entity-wizard': 'clients-management:account:update',
  'clients-management:erase-account-data': 'clients-management:account:update',
  'clients-management:erase-user-data': 'clients-management:user-profiles:delete',
  'clients-management:generate-app-login-url': 'clients-management:sync:internal',
  'clients-management:get-login-user': 'clients-management:account:read',
  'clients-management:me': 'clients-management:account:read',
  'clients-management:observation-state': 'clients-management:account:read',
  'clients-management:register-user-for-business-account': 'clients-management:user-profiles:create',
  'clients-management:register-user-profile': 'clients-management:user-profiles:create',
  'clients-management:remove-account-user': 'clients-management:account:members:delete',
  'clients-management:remove-group-member': 'clients-management:assignment-groups:update',
  'clients-management:remove-user-profile': 'clients-management:user-profiles:delete',
  'clients-management:rename-assignment-group': 'clients-management:assignment-groups:update',
  'clients-management:reopen-billing-entity-wizard': 'clients-management:account:update',
  'clients-management:set-new-accounts-subscription-plan': 'clients-management:subscription:update',
  'clients-management:set-trial-plan-duration': 'clients-management:subscription:update',
  'clients-management:subscription-plans-readmodel': 'clients-management:subscription:read',
  'clients-management:suspension-status': 'clients-management:account:read',
  'clients-management:update-account-info': 'clients-management:account:update',
  'clients-management:update-subscription-plan': 'clients-management:subscription:update',
  'clients-management:update-user-profile': 'clients-management:user-profiles:update',
  'clients-management:user-preferences': 'clients-management:user-profiles:read',
  'clients-management:users-profiles': 'clients-management:user-profiles:read',
  'feature-flags:archive-feature-flag': 'feature-flags:update',
  'feature-flags:create-feature-flag': 'feature-flags:create',
  'feature-flags:disable-feature-flag': 'feature-flags:update',
  'feature-flags:enable-feature-flag': 'feature-flags:update',
  'feature-flags:feature-flags': 'feature-flags:read',
  'feature-flags:import-feature-flags': 'feature-flags:create',
  'feature-flags:org-resolved-flags': 'feature-flags:self:read',
  'feature-flags:schedule-feature-flag': 'feature-flags:update',
  'feature-flags:update-feature-flag': 'feature-flags:update',
  'generic:realtime-session': 'generic:self:realtime',
  'generic:upload-file': 'generic:admin:infra',
  'generic:upload-image': 'generic:admin:infra',
  'identity:add-auth-user-password': 'identity:users:reset-password',
  'identity:admin-ban-user': 'identity:users:update',
  'identity:admin-create-admin-user': 'identity:users:create',
  'identity:admin-impersonate': 'identity:users:impersonate',
  'identity:admin-list-sessions': 'identity:users:read',
  'identity:admin-revoke-all-sessions': 'identity:sessions:revoke',
  'identity:admin-revoke-session': 'identity:sessions:revoke',
  'identity:admin-set-password': 'identity:users:reset-password',
  'identity:admin-stop-impersonating': 'identity:users:impersonate',
  'identity:admin-unban-user': 'identity:users:update',
  'identity:assign-account-membership': 'identity:users:create',
  'identity:auth-user-security': 'identity:users:read',
  'identity:auth-user-security-search': 'identity:users:read',
  'identity:ban-auth-user': 'identity:users:update',
  'identity:capability-registry': 'identity:roles:update',
  'identity:change-auth-user-password': 'identity:users:reset-password',
  'identity:custom-roles': 'identity:roles:update',
  'identity:define-custom-role': 'identity:roles:create',
  'identity:delete-auth-account': 'identity:accounts:delete',
  'identity:delete-auth-user': 'identity:users:delete',
  'identity:edit-custom-role': 'identity:roles:update',
  'identity:flags': 'identity:accounts:read',
  'identity:forgot-password': 'identity:users:reset-password',
  'identity:impersonate-auth-user': 'identity:users:impersonate',
  'identity:logout-authentication-user': 'identity:auth:anonymous',
  'identity:me': 'identity:self:read',
  'identity:my-capabilities': 'identity:self:read',
  'identity:passkey-delete': 'identity:passkeys:delete',
  'identity:passkey-register-start': 'identity:auth:anonymous',
  'identity:register-auth-account': 'identity:accounts:create',
  'identity:register-auth-user': 'identity:users:create',
  'identity:register-passkey': 'identity:passkeys:create',
  'identity:remove-account-membership': 'identity:users:delete',
  'identity:remove-custom-role': 'identity:roles:delete',
  'identity:reset-password': 'identity:users:reset-password',
  'identity:revoke-all-auth-user-sessions': 'identity:sessions:revoke',
  'identity:revoke-auth-user-session': 'identity:sessions:revoke',
  'identity:revoke-passkey': 'identity:passkeys:delete',
  'identity:role-create': 'identity:roles:create',
  'identity:role-delete': 'identity:roles:delete',
  'identity:role-update': 'identity:roles:update',
  'identity:set-active-account': 'identity:accounts:update',
  'identity:set-auth-user-password': 'identity:users:reset-password',
  'identity:stop-impersonating-auth-user': 'identity:users:impersonate',
  'identity:system-roles': 'identity:roles:update',
  'identity:unban-auth-user': 'identity:users:update',
  'identity:update-auth-account': 'identity:accounts:update',
  'identity:update-auth-user': 'identity:users:update',
  'identity:update-membership-roles': 'identity:users:update',
  'invoicing:add-billing-entity': 'invoicing:billing-entities:create',
  'invoicing:billing-entities': 'invoicing:billing-entities:read',
  'invoicing:billing-entity-points-of-sale': 'invoicing:billing-entities:read',
  'invoicing:buyer-invoice-preferences': 'invoicing:internal',
  'invoicing:confirm-credit-note': 'invoicing:internal',
  'invoicing:confirm-debit-note': 'invoicing:internal',
  'invoicing:disable-billing-entity': 'invoicing:billing-entities:disable',
  'invoicing:edit-billing-entity': 'invoicing:billing-entities:update',
  'invoicing:fiscal-documents': 'invoicing:fiscal-documents:read',
  'invoicing:generate-invoice': 'invoicing:fiscal-documents:generate',
  'invoicing:generate-invoice-from-order': 'invoicing:fiscal-documents:generate',
  'invoicing:issue-credit-note': 'invoicing:fiscal-documents:generate',
  'invoicing:issue-credit-note-from-reversal': 'invoicing:fiscal-documents:generate',
  'invoicing:issue-debit-note': 'invoicing:fiscal-documents:generate',
  'invoicing:issue-fiscal-note': 'invoicing:fiscal-documents:generate',
  'invoicing:taxpayer-registry': 'invoicing:billing-entities:read',
  'invoicing:void-invoice': 'invoicing:fiscal-documents:generate',
  'items-publishing:account-configuration-readmodel': 'items-publishing:configuration:update',
  'items-publishing:add-publication': 'items-publishing:publications:create',
  'items-publishing:apply-bulk-items-change': 'items-publishing:items:bulk',
  'items-publishing:apply-bulk-price-change': 'items-publishing:items:bulk',
  'items-publishing:change-conflicted-sku': 'items-publishing:items:update',
  'items-publishing:change-inventory-list-preferences': 'items-publishing:items:update',
  'items-publishing:channels-commisions': 'items-publishing:publications:read',
  'items-publishing:channels-publication-default-values-type': 'items-publishing:publications:read',
  'items-publishing:channels-publication-form-type': 'items-publishing:publications:read',
  'items-publishing:create-item-with-stock': 'items-publishing:items:create',
  'items-publishing:create-items-publishing-account-configuration': 'items-publishing:configuration:create',
  'items-publishing:create-items-publishing-user-preferences': 'items-publishing:items:create',
  'items-publishing:delete-item': 'items-publishing:items:delete',
  'items-publishing:delete-price-list': 'items-publishing:price-lists:delete',
  'items-publishing:delete-publication': 'items-publishing:publications:delete',
  'items-publishing:delete-size-guide': 'items-publishing:size-guides:manage',
  'items-publishing:destroy-items-publishing-user-preferences': 'items-publishing:items:delete',
  'items-publishing:duplicate-diff': 'items-publishing:publications:read',
  'items-publishing:duplicate-publication': 'items-publishing:publications:create',
  'items-publishing:edit-item': 'items-publishing:items:update',
  'items-publishing:edit-publication': 'items-publishing:publications:update',
  'items-publishing:fenicio-publications-readmodel': 'items-publishing:publications:read',
  'items-publishing:generate-sku': 'items-publishing:items:read',
  'items-publishing:get-sku-template': 'items-publishing:items:read',
  'items-publishing:import-publication': 'items-publishing:publications:import',
  'items-publishing:import-publications': 'items-publishing:publications:import',
  'items-publishing:inventory': 'items-publishing:items:read',
  'items-publishing:inventory-distinct-categories': 'items-publishing:items:read',
  'items-publishing:inventory-search': 'items-publishing:items:read',
  'items-publishing:inventory-spreadsheet': 'items-publishing:items:read',
  'items-publishing:inventory-stock-break': 'items-publishing:items:read',
  'items-publishing:item-delete-preflight': 'items-publishing:items:delete',
  'items-publishing:mercadolibre-categories': 'items-publishing:taxonomies:manage',
  'items-publishing:mercadolibre-discover-category-by-title': 'items-publishing:taxonomies:manage',
  'items-publishing:mercadolibre-search-products-catalog': 'items-publishing:taxonomies:manage',
  'items-publishing:merge-items': 'items-publishing:items:update',
  'items-publishing:order-items-search': 'items-publishing:items:read',
  'items-publishing:price-lists': 'items-publishing:price-lists:read',
  'items-publishing:productos': 'items-publishing:items:read',
  'items-publishing:productos-parcial': 'items-publishing:items:read',
  'items-publishing:publication-drift-episodes': 'items-publishing:publications:read',
  'items-publishing:publication-drift-episodes-search': 'items-publishing:publications:read',
  'items-publishing:publications': 'items-publishing:publications:read',
  'items-publishing:publications-bulk-edit-results': 'items-publishing:bulk-edit-results:read',
  'items-publishing:publications-count': 'items-publishing:publications:read',
  'items-publishing:publications-distinct-categories': 'items-publishing:publications:read',
  'items-publishing:publications-retail-codes': 'items-publishing:publications:read',
  'items-publishing:publications-search': 'items-publishing:publications:read',
  'items-publishing:publicationsIds': 'items-publishing:publications:read',
  'items-publishing:record-external-publication-error': 'items-publishing:publications:update',
  'items-publishing:register-item': 'items-publishing:items:create',
  'items-publishing:release-composite-components': 'items-publishing:items:update',
  'items-publishing:relist-publication': 'items-publishing:publications:delete',
  'items-publishing:remove-category-sku-formula-override': 'items-publishing:items:update',
  'items-publishing:search': 'items-publishing:items:read',
  'items-publishing:set-category-sku-formula-override': 'items-publishing:items:update',
  'items-publishing:set-item-composition': 'items-publishing:items:update',
  'items-publishing:set-publication-channel-values': 'items-publishing:publications:update',
  'items-publishing:size-guides': 'items-publishing:size-guides:manage',
  'items-publishing:size-guides-active-domains': 'items-publishing:size-guides:manage',
  'items-publishing:size-guides-channel-charts': 'items-publishing:size-guides:manage',
  'items-publishing:size-guides-publish-to-channel': 'items-publishing:size-guides:manage',
  'items-publishing:size-guides-search': 'items-publishing:size-guides:manage',
  'items-publishing:substitute-bom-components': 'items-publishing:items:update',
  'items-publishing:upsert-inventory-bulk-edit-views': 'items-publishing:items:update',
  'items-publishing:upsert-inventory-price-lists-views': 'items-publishing:items:update',
  'items-publishing:upsert-inventory-stock-lists-views': 'items-publishing:items:update',
  'items-publishing:upsert-price-list': 'items-publishing:price-lists:update',
  'items-publishing:upsert-publications-bulk-edit-views': 'items-publishing:publications:update',
  'items-publishing:upsert-size-guide': 'items-publishing:size-guides:manage',
  'items-publishing:user-preferences-readmodel': 'items-publishing:items:read',
  'items-publishing:validate-publication': 'items-publishing:items:update',
  'marketplace-health:listing-visits-readmodel': 'marketplace-health:visits:read',
  'marketplace-health:marketplace-health-force-sync': 'marketplace-health:reputation:sync',
  'marketplace-health:seller-reputation-readmodel': 'marketplace-health:reputation:read',
  'ml-and-ai:add-assistant-message': 'ml-and-ai:assistant:use',
  'ml-and-ai:add-user-message': 'ml-and-ai:assistant:use',
  'ml-and-ai:ai-assistant-feedback': 'ml-and-ai:assistant:use',
  'ml-and-ai:ai-assistant-send-message': 'ml-and-ai:assistant:use',
  'ml-and-ai:ai-assistant-submit-automation-request': 'ml-and-ai:assistant:use',
  'ml-and-ai:conversation-messages': 'ml-and-ai:assistant:use',
  'ml-and-ai:conversations': 'ml-and-ai:assistant:use',
  'ml-and-ai:fail-agent-run': 'ml-and-ai:agents:run',
  'ml-and-ai:finish-agent-run': 'ml-and-ai:agents:run',
  'ml-and-ai:interrupt-agent-run': 'ml-and-ai:agents:run',
  'ml-and-ai:resume-agent-run': 'ml-and-ai:agents:run',
  'ml-and-ai:start-agent-run': 'ml-and-ai:agents:run',
  'notifications:mark-notification-as-read': 'notifications:read',
  'notifications:mark-notification-as-unread': 'notifications:read',
  'notifications:notifications': 'notifications:read',
  'notifications:notifications-count': 'notifications:read',
  'notifications:send-user-notification': 'notifications:send',
  'operations:amend-change-item': 'operations:runs:approve',
  'operations:approve-operation': 'operations:runs:approve',
  'operations:change-sets': 'operations:runs:read',
  'operations:fail-operation-compute': 'operations:internal',
  'operations:propose-operation': 'operations:runs:propose',
  'operations:reject-operation': 'operations:runs:approve',
  'operations:runs': 'operations:runs:read',
  'operations:runs-search': 'operations:runs:read',
  'procurement:cancel-purchase-order': 'procurement:purchase-orders:manage',
  'procurement:clear-preferred-supplier': 'procurement:suppliers:manage',
  'procurement:deactivate-supplier': 'procurement:suppliers:manage',
  'procurement:edit-supplier': 'procurement:suppliers:manage',
  'procurement:item-sourcing': 'procurement:suppliers:read',
  'procurement:map-supplier-sku': 'procurement:suppliers:manage',
  'procurement:place-purchase-order': 'procurement:purchase-orders:manage',
  'procurement:purchase-orders': 'procurement:purchase-orders:read',
  'procurement:reactivate-supplier': 'procurement:suppliers:manage',
  'procurement:register-supplier': 'procurement:suppliers:manage',
  'procurement:set-preferred-supplier': 'procurement:suppliers:manage',
  'procurement:suppliers': 'procurement:suppliers:read',
  'procurement:unmap-supplier-sku': 'procurement:suppliers:manage',
  'sales:account-configuration': 'sales:configuration:manage',
  'sales:answer-channel-question': 'sales:messaging:questions:answer',
  'sales:assign-billing-entity': 'sales:orders:place',
  'sales:cancel-order': 'sales:orders:update-status',
  'sales:change-order-status': 'sales:orders:update-status',
  'sales:create-sales-account-configuration': 'sales:configuration:manage',
  'sales:crm-force-sync-questions': 'sales:messaging:questions:sync',
  'sales:customers': 'sales:customers:read',
  'sales:customers-search': 'sales:customers:read',
  'sales:messages': 'sales:messaging:messages:read',
  'sales:order-statuses': 'sales:orders:read',
  'sales:orders': 'sales:orders:read',
  'sales:orders-count': 'sales:orders:read',
  'sales:orders-search': 'sales:orders:read',
  'sales:ordersIds': 'sales:orders:read',
  'sales:outbound-messages': 'sales:messaging:messages:read',
  'sales:place-order': 'sales:orders:place',
  'sales:questions': 'sales:messaging:questions:read',
  'sales:record-shipment-status': 'sales:orders:update-status',
  'sales:register-customer': 'sales:customers:manage',
  'sales:register-shipment': 'sales:orders:update-status',
  'sales:return-order': 'sales:orders:update-status',
  'sales:reversal-fact-readmodel': 'sales:analytics:read',
  'sales:sales-analytics-readmodel': 'sales:analytics:read',
  'sales:send-channel-message': 'sales:messaging:messages:send',
  'sales:send-free-text-channel-message': 'sales:messaging:messages:send-free-text',
  'sales:set-order-statuses': 'sales:configuration:manage',
  'stock-management:apply-bulk-stock-change': 'stock-management:stock:bulk',
  'stock-management:delete-warehouse-item': 'stock-management:stock:update',
  'stock-management:edit-warehouse': 'stock-management:warehouses:update',
  'stock-management:increase-warehouse-item-stock-available': 'stock-management:stock:update',
  'stock-management:initialize-multiple-warehouse-items-stock': 'stock-management:stock:bulk',
  'stock-management:initialize-warehouse-item-stock': 'stock-management:stock:update',
  'stock-management:modify-warehouse-assignment': 'stock-management:warehouses:assign',
  'stock-management:movements-by-order': 'stock-management:stock:read',
  'stock-management:register-warehouse': 'stock-management:warehouses:create',
  'stock-management:remove-warehouse': 'stock-management:warehouses:delete',
  'stock-management:set-default-warehouse': 'stock-management:warehouses:update',
  'stock-management:set-warehouse-item-stock-available': 'stock-management:stock:update',
  'stock-management:shortfalls': 'stock-management:stock:read',
  'stock-management:stock-analytics-readmodel': 'stock-management:stock:read',
  'stock-management:update-multiple-warehouse-items-stock': 'stock-management:stock:update',
  'stock-management:warehouse-config': 'stock-management:warehouses:read',
  'stock-management:warehouses': 'stock-management:warehouses:read',
  'systems-integrations:account-emails': 'sales-channels:read',
  'systems-integrations:assign-integration-assignee': 'sales-channels:integrations:assign',
  'systems-integrations:by-sku': 'sales-channels:test-channel:read',
  'systems-integrations:change-system-integration-connector-state': 'sales-channels:integrations:configure',
  'systems-integrations:change-system-integration-state': 'sales-channels:integrations:configure',
  'systems-integrations:channel-categories': 'sales-channels:read',
  'systems-integrations:channel-categories-search': 'sales-channels:read',
  'systems-integrations:channel-import-preview': 'sales-channels:read',
  'systems-integrations:channel-import-preview-discard': 'sales-channels:integrations:disconnect',
  'systems-integrations:channel-import-preview-fetch-by-i-ds': 'sales-channels:read',
  'systems-integrations:channel-import-preview-prepare': 'sales-channels:read',
  'systems-integrations:channel-import-preview-resolve-selection': 'sales-channels:read',
  'systems-integrations:channel-import-preview-stop': 'sales-channels:integrations:disconnect',
  'systems-integrations:confirm-systems-integrations-element-operation': 'sales-channels:integrations:configure',
  'systems-integrations:confirm-systems-integrations-operation': 'sales-channels:integrations:configure',
  'systems-integrations:erp-container-import-price-list-import': 'sales-channels:integrations:configure',
  'systems-integrations:erp-container-import-warehouse-import': 'sales-channels:integrations:configure',
  'systems-integrations:erp-drift-episodes': 'sales-channels:read',
  'systems-integrations:erp-drift-episodes-search': 'sales-channels:read',
  'systems-integrations:erp-drift-recheck': 'sales-channels:integrations:configure',
  'systems-integrations:erp-price-import-price-import': 'sales-channels:integrations:configure',
  'systems-integrations:erp-stock-import-stock-import': 'sales-channels:integrations:configure',
  'systems-integrations:erp-sync-mirror': 'sales-channels:read',
  'systems-integrations:erp-sync-mirror-search': 'sales-channels:read',
  'systems-integrations:external-logistics-integrations': 'sales-channels:read',
  'systems-integrations:external-systems-integrations': 'sales-channels:read',
  'systems-integrations:link-mercadolibre-from-login': 'sales-channels:integrations:provision',
  'systems-integrations:map-channel-category': 'sales-channels:integrations:configure',
  'systems-integrations:mark-channel-category-unmappable': 'sales-channels:integrations:configure',
  'systems-integrations:mark-integration-credential-restored': 'generic:admin:integration-credential-state',
  'systems-integrations:mark-integration-credential-revoked': 'generic:admin:integration-credential-state',
  'systems-integrations:order-shipments-readmodel': 'sales-channels:test-channel:read',
  'systems-integrations:price-import-projection': 'sales-channels:read',
  'systems-integrations:price-list-discovery': 'sales-channels:read',
  'systems-integrations:provision-system-integration': 'sales-channels:integrations:provision',
  'systems-integrations:provision-system-integration-connector': 'sales-channels:integrations:provision',
  'systems-integrations:read-external-systems': 'sales-channels:read',
  'systems-integrations:record-account-email-outcome': 'sales-channels:account-email:send',
  'systems-integrations:remove-integration-assignee': 'sales-channels:integrations:assign',
  'systems-integrations:request-categories-resync': 'sales-channels:integrations:configure',
  'systems-integrations:request-erp-bulk-import': 'sales-channels:integrations:configure',
  'systems-integrations:request-systems-integrations-element-operation': 'sales-channels:integrations:configure',
  'systems-integrations:request-systems-integrations-operation': 'sales-channels:integrations:configure',
  'systems-integrations:send-account-email': 'sales-channels:account-email:send',
  'systems-integrations:stock-import-projection': 'sales-channels:read',
  'systems-integrations:storefront-link': 'sales-channels:test-channel:read',
  'systems-integrations:sync-channel-categories': 'sales-channels:integrations:configure',
  'systems-integrations:systems-integrations-connectors': 'sales-channels:read',
  'systems-integrations:systems-integrations-poll-publications': 'sales-channels:integrations:configure',
  'systems-integrations:systems-integrations-poll-shipments': 'sales-channels:integrations:configure',
  'systems-integrations:test-channel-create-publication': 'sales-channels:test-channel:operate',
  'systems-integrations:test-channel-edit-publication': 'sales-channels:test-channel:operate',
  'systems-integrations:test-channel-logistics-shipment-update': 'sales-channels:test-channel:operate',
  'systems-integrations:test-channel-poll-shipment-statuses': 'sales-channels:test-channel:operate',
  'systems-integrations:test-channel-record-invoice': 'sales-channels:test-channel:operate',
  'systems-integrations:test-channel-remove-publication': 'sales-channels:test-channel:operate',
  'systems-integrations:test-channel-set-invoicing-behavior': 'sales-channels:test-channel:operate',
  'systems-integrations:test-channel-sync-publication': 'sales-channels:test-channel:operate',
  'systems-integrations:test-channel-update-order-status': 'sales-channels:test-channel:operate',
  'systems-integrations:test-channel-update-publication-stock': 'sales-channels:test-channel:operate',
  'systems-integrations:unmap-channel-category': 'sales-channels:integrations:configure',
  'systems-integrations:update-system-integration-configuration': 'sales-channels:integrations:configure',
  'systems-integrations:update-system-integration-connector-configuration': 'sales-channels:integrations:configure',
  'systems-integrations:warehouse-discovery': 'sales-channels:read'
} as const;
